import script from "./AddUserModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddUserModal.vue?vue&type=script&setup=true&lang=js"

import "./AddUserModal.vue?vue&type=style&index=0&id=dded17a4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dded17a4"]])

export default __exports__